function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#131212",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.291 1.035a5.292 5.292 0 015.291 5.291c0 2.503-3.88 8.735-4.994 10.476a.352.352 0 01-.594 0C4.88 15.062 1 8.83 1 6.326a5.29 5.29 0 015.291-5.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.175 6.326a2.116 2.116 0 104.231.003 2.116 2.116 0 00-4.231-.003z"
}));

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18
  }, props), _ref);
}

export default SvgLocation;